import { createStyles, type Theme } from '@material-ui/core/styles';

const timelineLayoutStyles = (theme: Theme) =>
  createStyles({
    timelineToolbar: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(1),
      margin: theme.spacing(2, 0),
    },
    timelineFilters: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
      gap: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
    },
    timelineFilterActions: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(1),
      gridColumn: '1 / -1',
    },
    timelineList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'grid',
      gap: theme.spacing(1),
    },
  });

const timelineContentStyles = (theme: Theme) =>
  createStyles({
    timelineCard: {
      padding: theme.spacing(1.5),
      border: `1px solid ${theme.palette.divider}`,
      display: 'grid',
      gap: theme.spacing(0.75),
    },
    timelineCritical: {
      borderLeft: `4px solid ${theme.palette.error.main}`,
    },
    timelineSelected: {
      borderColor: theme.palette.primary.main,
      background: theme.palette.action.selected,
    },
    timelineMeta: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    timelineGroup: {
      padding: theme.spacing(1),
      background: theme.palette.action.hover,
      borderRadius: theme.shape.borderRadius,
    },
    timelineState: { margin: theme.spacing(2, 0) },
    timelineFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      marginTop: theme.spacing(2),
    },
  });

const timelineRevealStyles = (theme: Theme) =>
  createStyles({
    timelineMarkerReveal: {
      display: 'grid',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(1),
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  });

export const timelineStyles = (theme: Theme) =>
  createStyles({
    ...timelineRevealStyles(theme),
    ...timelineLayoutStyles(theme),
    ...timelineContentStyles(theme),
  });
